export function assertEnvHasProps(env, props) {
    var missing = props.filter(function (prop) { return !process.env[prop]; });
    if (missing.length) {
        throw new Error("Missing env vars: ".concat(missing.join(', ')));
    }
}
